export const prefillCheckoutData = function($data) {
	let test = {
		first_name: 'asdfsadf',
		last_name: 'asdfsadf',
		country: 'asdfasdf',
		state: 'Ciudad de México',
		street_1: '21312',
		street_2: 'Álvaro Obregón',
		street_3: 'adfas',
		city: 'asdfsadf',
		zip_code: '01780',
		phone: '5544444444',
		email: 'asdkj@lkjsad.com',
		references: 'adsfasd',
		//payment_method
		payment_method: 'card',
		//card
		credit_card: {
			number: '4242424242424242',
			name: 'diego',
			exp_month: '1',
			exp_year: '2019',
			cvc: '123',
		},
		//spei
		spei: false,
		//paypal
		paypal: false,
		//Discount Code
		discount_code: '',
		//terms accepted
		terms_accepted: false,
		//shipping data
		shippingData: 0	,
		shippingDataCache: {},
        //address
		// selectedAddress: null,//Null | Int | 'new_address'
		// sel/ectedCard: null//Null | Int | 'new_card'
		selectedAddress: 'new_address',//Null | Int | 'new_address'
		selectedCard: 'new_card'//Null | Int | 'new_card'
	}
	let keys = R.keys(test)
	keys.forEach(key => $data[key] = test[key])
}
